import { createContext } from "react";
export const PlacesContext = createContext({});